import React from 'react';
export function StepsSection() {
  return <section className="py-24 bg-white" data-id="element-160">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-161">
        <div className="text-center mb-16" data-id="element-162">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-stone-900 mb-6" data-id="element-163">
            Cómo funciona el sistema
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative" data-id="element-164">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-[16%] right-[16%] h-0.5 bg-stone-200 z-0" data-id="element-165"></div>

          {[{
          step: '1',
          title: 'Identifica',
          desc: 'Localiza las 3 Zonas de Fuego de tu entrada y sala.'
        }, {
          step: '2',
          title: 'Ejecuta',
          desc: 'Aplica la Técnica de la Caja del Caos y el Brillo de Superficie.'
        }, {
          step: '3',
          title: 'Respira',
          desc: 'Recibe a tus invitados con una sonrisa y una casa que huele a cítricos frescos.'
        }].map((item, i) => <div key={i} className="relative z-10 flex flex-col items-center text-center" data-id="element-166">
              <div className="w-24 h-24 bg-white border-4 border-orange-100 rounded-full flex items-center justify-center text-3xl font-serif font-bold text-orange-600 mb-6 shadow-sm" data-id="element-167">
                {item.step}
              </div>
              <h3 className="text-2xl font-bold text-stone-900 mb-4" data-id="element-168">
                {item.title}
              </h3>
              <p className="text-stone-600 text-lg" data-id="element-169">{item.desc}</p>
            </div>)}
        </div>

        <div className="mt-24 bg-orange-50 rounded-3xl p-8 md:p-12 text-center border border-orange-100" data-id="element-170">
          <h3 className="text-2xl font-serif font-bold text-stone-900 mb-4" data-id="element-171">
            Lo que cambia en 15 minutos:
          </h3>
          <p className="text-xl text-stone-700 max-w-3xl mx-auto leading-relaxed italic" data-id="element-172">
            "Pasarás de la parálisis total a tener una sala despejada, una
            cocina que brilla y la confianza de invitar a alguien a pasar,
            incluso si recibiste el aviso hace solo 10 minutos. No es magia, es
            prioridad visual aplicada."
          </p>
        </div>
      </div>
    </section>;
}